import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { selectFlexibleDialogIsOpened } from 'src/app/ngrx/misc/misc.selectors';

@Component({
  selector: 'create-link-button',
  templateUrl: './create-link-button.component.html',
  styleUrls: ['./create-link-button.component.scss'],
  standalone: true,
})
export class CreateLinkButtonComponent implements OnDestroy {
  @Input() createText: string;
  @Input() createLink: any;

  flexibleDialogIsOpen: boolean;
  subs$: Subscription = new Subscription();

  constructor(private router: Router, private store$: Store) {
    this.subs$.add(this.store$.select(selectFlexibleDialogIsOpened).subscribe((isOpened) => this.flexibleDialogIsOpen));
  }

  onClick(): void {
    this.router.navigate(this.createLink);
  }

  ngOnDestroy(): void {
    this.subs$.unsubscribe();
  }
}
